import { HttpErrorResponse } from "@angular/common/http";

import { FiscalRegime } from "@core/models/fiscal-regime.model";
import { FundWithRelated } from "@core/models/fund-with-related.model";
import { Product } from "@core/models/product.model";
import { ProductKind } from "@core/models/product-kind.model";
import { ProductVersions } from "@core/models/product-versions.model";
import { ProductsInfo } from "@core/models/products-info.model";
import { TPagination } from "@custom-types/sorting";
import { createAction, props } from "@ngrx/store";

export const LOAD_PRODUCTS = createAction(
  "[Product] Load Products",
  props<{
    activeVersions?: boolean;
    pagination?: Partial<TPagination> | undefined;
  }>()
);

export const LOAD_COMPANY_PRODUCTS = createAction(
  "[Product] Load Company Products ",
  props<{ companyProducts: boolean; activeVersions?: boolean }>()
);

export const SET_PRODUCTS = createAction(
  "[Product] Set Products",
  props<{ productList: Array<Product> }>()
);

export const SET_COMPANY_PRODUCTS = createAction(
  "[Product] Set Company Products",
  props<{ productList: Array<Product> }>()
);

export const SET_PRODUCTS_LOADING_STATUS = createAction(
  "[Product] Set Product Loading Status",
  props<{ loading: boolean }>()
);

export const SET_PRODUCTS_ERROR = createAction(
  "[Product] Set Product Error",
  props<{ error: HttpErrorResponse }>()
);

export const LOAD_PRODUCT = createAction(
  "[Product] Load Product",
  props<{ id: string }>()
);

export const LOAD_FUNDS = createAction("[Product] Load Funds");

export const SET_FUNDS = createAction(
  "[Product] Set Funds",
  props<{ fundsList: Array<FundWithRelated> }>()
);

export const LOAD_FISCAL_REGIME = createAction("[Product] Load Fiscal Regime");

export const SET_FISCAL_REGIME = createAction(
  "[Product] Set Fiscal Regime",
  props<{ fiscalRegimeList: Array<FiscalRegime> }>()
);

export const SAVE_PRODUCT = createAction(
  "[Product] Save Product",
  props<{ product: Partial<Product>; id: string | undefined }>()
);

export const SAVE_PRODUCT_VERSION = createAction(
  "[Product] Save Product Version",
  props<{ productVersion: Partial<ProductVersions>; id: string | undefined }>()
);

export const SET_PRODUCTS_INFO = createAction(
  "[Product] Set Products Info",
  props<{ productsInfo: ProductsInfo }>()
);

export const LOAD_PRODUCT_KIND = createAction("[Product] Load Product Kind");

export const SET_PRODUCT_KIND = createAction(
  "[Product] Set Products Kind",
  props<{ productKindList: Array<ProductKind> }>()
);

export const LOAD_NON_DEVIATED_COSTS_COUNT = createAction(
  "[Product] Load Non Deviated Costs Count",
  props<{ id: string }>()
);

export const SET_NON_DEVIATED_COSTS_COUNT = createAction(
  "[Product] Set Non Deviated Costs Count",
  props<{ nonDeviatedCostsCount: number }>()
);

export const SET_PRODUCTS_PAGINATION = createAction(
  "[Product] Set Products Pagination",
  props<{ pagination: Partial<TPagination> | undefined }>()
);
